import { HttpClient } from '@wix/sdk-types';
import {
  AddInvoiceToOrderResponse,
  AddInvoiceToOrderResponseNonNullableFields,
  BulkGenerateInvoicesResponse,
  BulkGenerateInvoicesResponseNonNullableFields,
  GenerateInvoiceResponse,
  GenerateInvoiceResponseNonNullableFields,
  Invoice,
  ListInvoicesForMultipleOrdersResponse,
  ListInvoicesForMultipleOrdersResponseNonNullableFields,
  addInvoiceToOrder as universalAddInvoiceToOrder,
  bulkGenerateInvoices as universalBulkGenerateInvoices,
  generateInvoice as universalGenerateInvoice,
  listInvoicesForMultipleOrders as universalListInvoicesForMultipleOrders,
} from './ecom-orders-v1-invoice-order-invoices.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function listInvoicesForMultipleOrders(
  httpClient: HttpClient
): ListInvoicesForMultipleOrdersSignature {
  return (orderIds: string[]) =>
    universalListInvoicesForMultipleOrders(
      orderIds,
      // @ts-ignore
      { httpClient }
    );
}

interface ListInvoicesForMultipleOrdersSignature {
  /**
   * Retrieves the IDs of invoices associated with all specified orders.
   *
   *
   * The `listInvoicesForSingleOrder()` function returns a Promise that resolves when the specified order's transaction records are retrieved.
   * @param - Order IDs for which to retrieve invoices.
   */
  (orderIds: string[]): Promise<
    ListInvoicesForMultipleOrdersResponse &
      ListInvoicesForMultipleOrdersResponseNonNullableFields
  >;
}

/** @internal */
export function generateInvoice(
  httpClient: HttpClient
): GenerateInvoiceSignature {
  return (orderId: string) =>
    universalGenerateInvoice(
      orderId,
      // @ts-ignore
      { httpClient }
    );
}

interface GenerateInvoiceSignature {
  /**
   * Generates and adds an invoice to a specified order.
   * @param - Order ID.
   */
  (orderId: string): Promise<
    GenerateInvoiceResponse & GenerateInvoiceResponseNonNullableFields
  >;
}

/** @internal */
export function bulkGenerateInvoices(
  httpClient: HttpClient
): BulkGenerateInvoicesSignature {
  return (orderIds: string[]) =>
    universalBulkGenerateInvoices(
      orderIds,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkGenerateInvoicesSignature {
  /**
   * Generates and adds invoices to all specified orders.
   * @param - Order IDs.
   */
  (orderIds: string[]): Promise<
    BulkGenerateInvoicesResponse & BulkGenerateInvoicesResponseNonNullableFields
  >;
}

/** @internal */
export function addInvoiceToOrder(
  httpClient: HttpClient
): AddInvoiceToOrderSignature {
  return (orderId: string, invoiceInfo: Invoice) =>
    universalAddInvoiceToOrder(
      orderId,
      invoiceInfo,
      // @ts-ignore
      { httpClient }
    );
}

interface AddInvoiceToOrderSignature {
  /**
   * Adds an invoice to a specified order.
   * @param - Order ID.
   * @param - Invoice info.
   */
  (orderId: string, invoiceInfo: Invoice): Promise<
    AddInvoiceToOrderResponse & AddInvoiceToOrderResponseNonNullableFields
  >;
}

export {
  ActionEvent,
  AddInvoiceToOrderRequest,
  AddInvoiceToOrderResponse,
  AddInvoiceToOrderResponseNonNullableFields,
  ApplicationError,
  BulkActionMetadata,
  BulkGenerateInvoicesRequest,
  BulkGenerateInvoicesResponse,
  BulkGenerateInvoicesResponseNonNullableFields,
  BulkInvoiceResult,
  DomainEvent,
  DomainEventBodyOneOf,
  Empty,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  GenerateInvoiceRequest,
  GenerateInvoiceResponse,
  GenerateInvoiceResponseNonNullableFields,
  GenerateInvoiceWithNumberRequest,
  GenerateInvoiceWithNumberResponse,
  GetOrderInvoiceRequest,
  GetOrderInvoiceResponse,
  IdentificationData,
  IdentificationDataIdOneOf,
  Invoice,
  InvoiceForOrder,
  InvoicesForOrder,
  ItemMetadata,
  ListInvoicesForMultipleOrdersRequest,
  ListInvoicesForMultipleOrdersResponse,
  ListInvoicesForMultipleOrdersResponseNonNullableFields,
  ListInvoicesForSingleOrderRequest,
  ListInvoicesForSingleOrderResponse,
  MessageEnvelope,
  RestoreInfo,
  WebhookIdentityType,
} from './ecom-orders-v1-invoice-order-invoices.universal.js';
